
import {
  FbmakeStyles,
  FbTypeography,
  FbList,
  FbListItem,
  FbListItemText,
} from "@flexibees/core";
import { COLORS } from "../../constants/colors";
import { CustomCheckbox } from "./CustomCheckbox";
import PropTypes from "prop-types";
import "./Filter.css";

const useStyles = FbmakeStyles((theme) => ({
  root: {
    maxHeight: 300,
    overflow: "auto",
    backgroundColor: COLORS.WHITE,
    border: "none",
    borderRadius: 10,
  },
  input: {
    marginBottom: 10,
    height: 36,
    padding: 10,
  },
}));

export default function JobStatusFliter({
  data,
  onChange,
  checked,
}) {
  const classes = useStyles();

    return (
      <FbList className={classes.root}>
        {!data.length && (
          <FbTypeography
            type="body2"
            style={{ color: COLORS.BLACK, textAlign: "center" }}
          >
            No Data
          </FbTypeography>
        )}
        {data &&
          data.map((item) => {
            const labelId = `checkbox-list-label-${item.id}`;
            return item ? (
              <FbListItem
                key={item.id || item}
                role={undefined}
                dense
                button
                onClick={onChange(item.id || item)}
              >
                <CustomCheckbox
                  edge="start"
                  checked={checked.indexOf(item.id || item) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />

                <FbListItemText
                  id={labelId}
                  disableTypography
                  primary={
                    <FbTypeography type="body2" style={{ color: COLORS.BLACK }}>
                      {typeof item === "object"
                        ? item.tag_name || item.first_name
                        : item}
                    </FbTypeography>
                  }
                />
              </FbListItem>
            ) : null;
          })}
      </FbList>
    );
  }

JobStatusFliter.propTypes = {
  data: PropTypes.array.isRequired,
  checked: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
